import './App.css';
import { Routes, Route } from 'react-router-dom';
import Usuarios from './pages/Usuarios';
import Dashboard from './pages/Dashboard';


import PanelAdmin from './pages/PanelAdmin';
import Perfil from './pages/Perfil';
import AdminUserProfilePage from './pages/AdminUserProfilePage';
import Security from './pages/Security';
import DeleteAccount from './pages/DeleteAccount';
import Login from './pages/Login';



function App() {



  return (
    <Routes>
      <Route path="/admin" element={<PanelAdmin />}>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<Usuarios />} />
        <Route path="user/:id" element={<Perfil />} />
        <Route path="user/:id/edit-profile" element={<AdminUserProfilePage />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/seguridad/abuso-infantil" element={<Security />} />
      <Route path="/seguridad/eliminar-cuenta" element={<DeleteAccount />} />
    </Routes>
  );
}

export default App;
